import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const selectComposeDatePickerProps = buildProps({
  modelValue: {
    type: Object,
    required: true,
  },
  options: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  labelKey: {
    type: String,
    default: "text",
  },
  valueKey: {
    type: String,
    default: "id",
  },
  config: {
    type: Object,
    default: () => {
      return {
        key: "key",
        value: "value",
      };
    },
  },
  leftWidth: {
    type: Number,
    default: 90,
  },
  rightWidth: {
    type: Number,
    default: 240,
  },
  selectProps: {
    type: Object,
  },
} as const);
export type SelectComposeDatePickerProps = ExtractPropTypes<
  typeof selectComposeDatePickerProps
>;
